import { store } from '../../store/store';
import { validateParams } from '../../utils/validateParams';
import { sendPost } from '../../api/sendPost';
var findHTMLForm = function findHTMLForm(form) {
  var currentForm;
  if (typeof form === 'string') {
    currentForm = document.querySelector(form);
  } else {
    currentForm = form;
  }
  if (!currentForm || currentForm.nodeName !== 'FORM') {
    throw 'The 3rd parameter is expected to be the HTML form element or the style selector of form';
  }
  return currentForm;
};
/**
 * Send a form the specific EmailJS service
 * @param {string} serviceID - the EmailJS service ID
 * @param {string} templateID - the EmailJS template ID
 * @param {string | HTMLFormElement} form - the form element or selector
 * @param {string} userID - the EmailJS user ID
 * @returns {Promise<EmailJSResponseStatus>}
 */
export var sendForm = function sendForm(serviceID, templateID, form, userID) {
  var uID = userID || store._userID;
  var currentForm = findHTMLForm(form);
  validateParams(uID, serviceID, templateID);
  var formData = new FormData(currentForm);
  formData.append('lib_version', '3.2.0');
  formData.append('service_id', serviceID);
  formData.append('template_id', templateID);
  formData.append('user_id', uID);
  return sendPost('/api/v1.0/email/send-form', formData);
};